module.exports = __webpack_public_path__ + "static/media/empty-cards-outline-72x72.5dc59a14.svg";